import { Avatar, Button, Card, Col, Popover, Row, Space, Typography } from 'antd';
import { Content } from 'antd/es/layout/layout';
import React, { useState } from 'react';
import englan from '../../../english.json';
import germanlan from '../../../german.json';
import arabiclan from '../../../arabic.json';
import frenchlan from '../../../french.json';
import hindilan from '../../../hindi.json';
import malayalamlan from '../../../malayalam.json';
import { PlusOutlined, InfoOutlined, BarcodeOutlined } from '@ant-design/icons';
import { useAuth } from '../../Context';
import { useEffect } from 'react';
import WaterfallCrud from './waterfall-crud';

const { Title } = Typography;

export default function WaterfallManagement () {
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const permission = localStorage.getItem(`${dashboardtype.toUpperCase()}_PERMISSION`);

	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;
	useAuth();

	const [openModal, setOpenModal] = useState(false);

	const handleOpenAddModal = () => {
		setOpenModal(true);
	};


	useEffect(() => {
		window.scrollTo(0, 0);
	},[]);

	const infoContent = (
		<Card size="small" bordered="false" type="inner" style={{ width: 300 }}> 
			<p>{ langdata && langdata.waterfallManagementContent ? langdata.waterfallManagementContent : 'This panel allows you to configure the real-time waterfall plot settings. \
			You can adjust the frequency bandwidth to filter signal ranges, set the distance axis (typically in meters) representing cable length, \
			and define the sample rate (Hz) to control signal resolution. The frames per second (FPS) setting determines how often the heatmap updates, \
			affecting responsiveness and performance. The intensity map lets you choose a color scale for signal amplitude visualization. \
			Suppressions help to suppress the activity indication in some area . The event confidence threshold allows you to control \
			which detected events are shown based on certainty levels—lower thresholds show more events but with less confidence.Finally the data log details.'}</p>
		</Card>
	);	

	return (
		<Content>
			<Row style={{
				margin: '10px',
				paddingLeft: '10px',
				paddingRight: '10px',
				background: '#FFFFFF',
				alignItems:'center',
			}}
			>
				<Col span={8}>
					<Row>
						<Space>
							<BarcodeOutlined style={{fontSize:'30px'}}/>
						</Space>
						<Space>&nbsp;&nbsp;</Space>
						<Title level={4} style={{ paddingTop:'10px'}}>{langdata && langdata.WaterfallManagement ? langdata.WaterfallManagement : 'Waterfall Management'}</Title>
					</Row>
				</Col>
				<Col span={16}>
					<Row justify="end">
						<Col>
							{ permission==='superadmin' || permission === 'admin' ? 
								<Space>
									<Space>&nbsp;</Space>
									<Button style={{margin:'5px'}} type="primary" onClick={handleOpenAddModal} ><PlusOutlined/>{langdata && langdata.AddNew ? langdata.AddNew : 'Add New'}</Button>
								</Space>
								: null }
							<Space>&nbsp;&nbsp;</Space>
							<Space>
								<Typography>
									<Popover title={ langdata && langdata.WaterfallManagement ? langdata.WaterfallManagement :'Waterfall Management'}  content={infoContent} trigger="click">
										<Avatar size="small"><InfoOutlined /></Avatar>
									</Popover>
								</Typography>
							</Space>
						</Col>
					</Row>
				</Col>
			</Row>
			<WaterfallCrud modal = {openModal} setOpenModal = {setOpenModal}/>
		</Content>
	);
}